import React from "react";
import ContextMenuItem from "../ContextMenuItem";
import useMainStore from "../../../stores/mainStore";
import {
    FaFileExport,
    FaFileImport,
    FaFolder,
    FaNoteSticky,
} from "react-icons/fa6";
import useDataStore from "../../../stores/dataStore";
import { importNoteFile } from "../../../utility/exportImportData";
import { useGetEditor } from "../../../context/useEditorContext";

function LeftScrollboxContextMenu() {
    const editor = useGetEditor().editor.current;
    const selectedFolderID = useMainStore(
        (state) => state.data.selectedFolderID
    );
    const inFolder = selectedFolderID !== undefined;

    return (
        <div>
            {inFolder && (
                <>
                    <ContextMenuItem
                        label="Add Note"
                        icon={<FaNoteSticky size={14} />}
                        callbackFunction={() => {
                            useDataStore.getState().add.note({
                                folderID: selectedFolderID,
                            });
                        }}
                    />

                    <ContextMenuItem
                        label="Import"
                        icon={<FaFileImport size={14} className="ml-[-2px]" />}
                        callbackFunction={() => {
                            importNoteFile(undefined, editor);
                        }}
                    />
                </>
            )}
            {!inFolder && (
                <>
                    <ContextMenuItem
                        label="Add Folder"
                        icon={<FaFolder size={14} />}
                        callbackFunction={() => {
                            useDataStore.getState().add.folder();
                        }}
                    />
                </>
            )}
        </div>
    );
}

export default LeftScrollboxContextMenu;
